angular.module('app')

	.controller('ContactController', ['$scope', '$timeout', function ContactController ($scope, $timeout)
	{
		var contact = this;
		var contactPage = document.getElementById('contact_page');
	}]);
